module.exports = __webpack_public_path__ + "b6e5ed1eb95b45984d198f08e99e8a11.fbx";